import {gsap} from "gsap";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {NineToFive} from "../../NineToFive";
import {NineToFiveGameAssets} from "../../NineToFiveGameAssets";
import {NineToFiveSymbol, SymbolArgs} from "./NineToFiveSymbol";
import {NineToFiveStatics} from "../../config/NineToFiveStatics";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";

export class FireSymbol extends NineToFiveSymbol {


    constructor(args:SymbolArgs) {
        if (NineToFive.model.data.mode == GameMode.FREESPIN_SUPER) {
            args.suffix = "_3" ;
        }
        super(args);

        if (NineToFive.model.data.mode == GameMode.FREESPIN_SUPER) {
            this.view.removeChild(this.overlay);
            this.overlay = new PIXI.Sprite(NineToFive.assetLoader.getTextures("M1_Tint")[0])
            this.overlay.alpha = 0;
            this.overlay.anchor.set(0.5,0.5);
            this.view.addChild(this.overlay)
        }
    }

    public moveToNormalLayer(object: PIXI.DisplayObject = this) {
        if (NineToFive.model.data.mode == GameMode.FREESPIN_SUPER) {
            this.reelsView.layers.maskedM1.addChild(object);
            (<NineToFiveSymbol[]>this.reelsView.layers.maskedM1.children).sort((a,b) => {
                return ((5 - a.reelID) * a.reelPosition) - ((5 - b.reelID) * b.reelPosition);
            })
        } else {
            super.moveToNormalLayer(object);
        }
    }

    public plusOne():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, "MP_Win"))
            .add(() => {
                this.winAnimation.alpha = 0;
                this.moveToNormalLayer();
            });
    }

    public plusThree():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, "MP_3_Win"))
            .add(() => {
                this.winAnimation.alpha = 0;
                this.moveToNormalLayer();
            });
    }
}

